export default "__VITE_ASSET__0MijpfXz__"